import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';
import {
  useHistory,
  //  Link
} from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  makeStyles,
  Tab,
  Tabs,
  useMediaQuery,
  // Typography,
} from '@material-ui/core';
import DriveEtaRoundedIcon from '@material-ui/icons/DriveEtaRounded';

import Style from './Style';
import {
  // InfoIcon,
  AddIcon,
} from '../../constants';
// import { checkInSubscription, isTrialEnds } from '../Utils/helper';
import TabPanelComp from './Components/TabPanel';
import CustomVehicle from './Components/CustomVehicle/CustomVehicle';
// import VehicleSlection from './Components/VehicleSlection';
import VinLookup from './Components/VinLookup';
import PlateLookup from './Components/PlateLookup';

const useStyles = makeStyles((theme) => Style(theme));

const TabPanel = (props) => TabPanelComp(props, useStyles(), Box);

export default function SearchVehicle({ toggle, setToggle }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);

  const {
    roData: { ro },
  } = useSelector((state) => state.ro);

  const { vehicle = {} } = ro || '';

  const selectedVehicle = useSelector(
    (state) =>
      state.customerVehicleSearch?.selectedCustomerAndVehicle?.vehicle ||
      vehicle,
  );

  const pathname = history.location?.pathname || '';

  useEffect(() => {
    if (pathname.includes('/dashboard')) {
      setToggle(false);
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);

    if (
      !(
        selectedVehicle?.id &&
        (pathname.includes('/estimator') ||
          pathname.includes('/new-repairorder'))
      )
    ) {
      dispatch({
        type: 'SET_VEHICLE_INFO_ON_HEADER',
        payload: '',
      });
    }
  };

  const allTabs = [
    {
      title: 'VIN Lookup',
      component: <VinLookup setToggle={setToggle} />,
    },

    {
      title: 'License Plate Lookup',
      component: <PlateLookup setToggle={setToggle} />,
    },
    {
      title: 'Custom Vehicle',
      component: <CustomVehicle setToggle={setToggle} />,
    },
    // {
    //   title: 'Vehicle Selection',
    //   // component: <ComingSoonComp />,
    //   component:
    //     checkInSubscription('ymme') && isTrialEnds() ? (
    //       <VehicleSlection setToggle={setToggle} />
    //     ) : (
    //       <div className={classes.coming__soon}>
    //         <InfoIcon className={classes.info__icon} />
    //         <Typography className={classes.coming__soon__heading}>
    //           {!checkInSubscription('ymme') ? ' Uh-oh!' : 'Upgrade Now!'}
    //         </Typography>
    //         <Typography className={classes.coming__soon__para}>
    //           {!checkInSubscription('ymme')
    //             ? 'This feature is not available in your current plan.
    // Upgrade now to unlock this feature.'
    //             : 'This feature is not available in the free trial.
    // Upgrade to a full plan today to unlock all the features.'}
    //         </Typography>
    //         <Link to='/settings?tab=6' underline='none'>
    //           <Button className={classes.main__btn}>
    //             {!checkInSubscription('ymme') ? 'Upgrade Now' : 'View Plans'}
    //           </Button>
    //         </Link>
    //       </div>
    //     ),
    // },
  ];
  const matchesMedia = useMediaQuery('(max-width:1500px)');

  return (
    <>
      <div className={clsx(classes.vehicle__info__bar, 'p-relative')}>
        <Button
          className={classes.add__btn}
          onClick={() => {
            setToggle(!toggle);
            setActiveTab(0);
          }}
          style={{ width: matchesMedia && '70px' }}
        >
          <AddIcon className={classes.start__icon} />{' '}
          {matchesMedia ? <DriveEtaRoundedIcon /> : 'New Vehicle'}
        </Button>
        {toggle && (
          <div className={classes.dropdown__main}>
            <AppBar position='sticky' className={classes.tabs__bar}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                aria-label='basic tabs example'
                classes={{
                  indicator: classes.indicator,
                }}
              >
                {allTabs?.map((tab) => tab.title && <Tab label={tab.title} />)}
              </Tabs>
            </AppBar>
            <TabPanel
              value={activeTab}
              index={activeTab}
              className={clsx(classes.tab__panel, classes.tab__panel__padding)}
            >
              {allTabs[activeTab].component}
            </TabPanel>
          </div>
        )}
      </div>
    </>
  );
}
